import React from 'react'

const NotificationPopup = ({
  showNotification,
  welcomeMessage,
  setShowNotification
}) => (
  <li className={`notification-popup2 ${showNotification ? 'show' : 'hide'}`}>
    {welcomeMessage}
    <span className="close-btn2" onClick={() => setShowNotification(false)}>
      &times;
    </span>
  </li>
)

export default NotificationPopup
